export const getDisplayName = (profile: any, isEntity: boolean) =>
  isEntity
    ? profile?.name ?? "-"
    : [profile?.first_name, profile?.middle_name, profile?.last_name]
        .filter(Boolean)
        .join(" ") || "-";

export const getGenderLabel = (gender?: string | null) =>
  gender
    ? String(gender).charAt(0).toUpperCase() + String(gender).slice(1)
    : "-";

export const getLeftMeta = (args: {
  isEntity: boolean;
  registrationNumber: string;
  entityTypeName: string;
  genderLabel: string;
  countryName: string;
}) => {
  const { isEntity, registrationNumber, entityTypeName, genderLabel, countryName } =
    args;

  return isEntity
    ? [registrationNumber !== "-" ? registrationNumber : null,
       entityTypeName !== "-" ? entityTypeName : null
      ].filter(Boolean).join(" • ")
    : [genderLabel !== "-" ? genderLabel : null,
       countryName !== "-" ? countryName : null
      ].filter(Boolean).join(" • ");
};
